import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/hooks';
import ErrorMessage from './ErrorMessage';
const FormField = ({ value, inputType, label, fieldName, placeHolder, errors, onInput }) => {
    const error = Object.entries(errors ?? {}).filter(p => p[0] === fieldName);
    const fieldValue = value[fieldName];
    const handleInput = useCallback((evt) => {
        onInput(fieldName, evt.currentTarget.value);
    }, []);
    return (_jsxs("div", Object.assign({ class: "field" }, { children: [label && (_jsx("label", Object.assign({ class: "label" }, { children: label }), void 0)),
            _jsx("input", { className: `input ${error.length > 0 ? 'is-danger' : ''}`, type: inputType, placeholder: placeHolder, value: fieldValue, onInput: handleInput }, void 0),
            _jsx(ErrorMessage, { errors: errors, field: fieldName }, void 0)] }), void 0));
};
export default FormField;
